import colors from '../foundation/colors';

const headerBaseStyle = {
  textStyle: 'displayXxs600',
  fontWeight: 'semibold',
  fontSize: '24px',
  letterSpacing: '-0.02em',
  lineHeight: '32px',
  color: colors.greyScale['900'],
  pt: '1rem',
  px: '2rem'
};

const bodyBaseStyle = {
  color: colors.greyScale['600'],
  textStyle: 'bodyMd',
  px: 8,
  pt: 3,
  pb: 2
};

const Modal = {
  parts: ['dialogContainer', 'dialog', 'header', 'body', 'footer'],
  baseStyle: {
    dialog: { p: 3, pb: '3rem' },
    header: headerBaseStyle,
    body: bodyBaseStyle,
    footer: { pt: 5, pb: 0 }
  },
  variants: {
    unstyled: {
      dialog: { p: 0, pb: 0 },
      body: { p: 0 }
    }
  },
  sizes: {},
  defaultProps: {}
};

export default Modal;
